import { Capacitor } from '@capacitor/core';
import { LoadableComponent, NoConnectionScreenComponent } from 'common/components';
import { useStartupConnectivity } from 'core/platform/connectivity/use-startup-connectivity.hook';
import React, { PropsWithChildren } from 'react';

export const StartupConnectivityGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const { status, isChecking, retry } = useStartupConnectivity({
    enabled: Capacitor.isNativePlatform(),
  });

  if (status === 'online') {
    return <>{children}</>;
  }

  return status === 'offline' ? (
    <NoConnectionScreenComponent isChecking={isChecking} onRetry={() => void retry()} />
  ) : (
    <LoadableComponent isLoading />
  );
};
